/* eslint-disable */
import { I18N_DIRECTION_LEFT_TO_RIGHT } from '../../../Constants/I18n/I18n.constants';
import throwParameterRequiredError from '../../../Errors/General/ParameterRequired.error';

/**
 * Determine if a given `direction` is a `ltr`
 * @export
 * @param {any} direction The direction to check
 * @returns {boolean} Whether or not `direction` is indeed `ltr`
 */
const i18nIsLtr = (direction = throwParameterRequiredError(`direction`)) => {
  return direction === I18N_DIRECTION_LEFT_TO_RIGHT;
};

export default i18nIsLtr;
